import { State, appendOrMoveToIndexWith, appendValue, moveTo } from '@btime/state-monad'
import { propEq } from 'ramda'
import { useMemo } from 'react'

// TODO: Move to helpers
export const useGroupedRepliesByCategory = replies => {
  return useMemo(
    () =>
      replies.reduce((list, reply) => {
        const { id, name } = reply.question.category || {}
        const categoryDefaultObj = { id, name, replies: [] }
        return State.of(list)
          .map(appendOrMoveToIndexWith(propEq('id', id), categoryDefaultObj))
          .map(moveTo('replies'))
          .map(appendValue(reply))
          .fold()
      }, []),
    [replies]
  )
}
